/**
 * Portfolio Summary Calculations
 * Pure functions for calculating portfolio metrics from position data
 */

/**
 * Calculate total realized P&L across all positions
 * @param {Array} positions - Array of position objects
 * @returns {number} Total realized P&L in lamports
 */
export function calculateTotalRealizedPnL(positions) {
  if (!positions || positions.length === 0) {
    return 0;
  }

  return positions.reduce((total, position) => {
    const realizedPnL = Number(position.realized_pnl_lamports || 0);
    return total + realizedPnL;
  }, 0);
}

/**
 * Calculate total number of games
 * @param {Array} positions - Array of position objects
 * @returns {number} Total number of games
 */
export function calculateTotalGames(positions) {
  if (!positions || positions.length === 0) {
    return 0;
  }

  return positions.length;
}

/**
 * Calculate number of open positions
 * @param {Array} positions - Array of position objects
 * @returns {number} Number of open positions
 */
export function calculateOpenPositions(positions) {
  if (!positions || positions.length === 0) {
    return 0;
  }

  return positions.filter(
    (position) => position.position_status === 'open'
  ).length;
}

/**
 * Calculate number of closed positions
 * @param {Array} positions - Array of position objects
 * @returns {number} Number of closed positions
 */
export function calculateClosedPositions(positions) {
  if (!positions || positions.length === 0) {
    return 0;
  }

  return positions.filter(
    (position) => position.position_status === 'closed'
  ).length;
}

/**
 * Calculate all summary metrics at once
 * @param {Array} positions - Array of position objects
 * @returns {object} Summary metrics object
 */
export function calculatePortfolioSummary(positions) {
  return {
    totalRealizedPnL: calculateTotalRealizedPnL(positions),
    totalGames: calculateTotalGames(positions),
    openPositions: calculateOpenPositions(positions),
    closedPositions: calculateClosedPositions(positions),
  };
}
